@import '@hevoio/hevo-ui-toolkit/styles/variables';
@import '@hevoio/hevo-ui-toolkit/styles/typography/typography-utils';

.fieldDataType {
  margin-left: $spacer * 0.25;
  flex-shrink: 2;
  color: $text-secondary;
  @include typography-level-to-styles(typography-config(), caption-1);
}

.treeViewPadding {
  padding: $spacer * 0.5 $spacer * 0.5 $spacer * 1.25 $spacer * 0.5;
}

.dialogBody {
  max-height: 550px;
  overflow: auto;
}

.nodePaddingLeft {
  padding-left: $spacer * 1.125;
}

.nodePaddingTop {
  padding-top: $spacer * 0.75;
}

.toggleArrow {
  margin-right: $spacer * 0.25;
  font-size: $icon-size-base * 0.875;
  transform: rotate(-90deg);
  flex-shrink: 0;
}

.toggleArrowToggled {
  transform: rotate(0deg);
}
